import { render, staticRenderFns } from "./OtherFormList.vue?vue&type=template&id=500f87e5"
import script from "./OtherFormList.vue?vue&type=script&lang=ts"
export * from "./OtherFormList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports